(function() {
  function init() {
    var footer = document.querySelector('footer.footer__section');
    if (!footer || document.getElementById('grain-canvas-footer')) return;

    footer.style.position = 'relative';

    var canvas = document.createElement('canvas');
    canvas.id = 'grain-canvas-footer';
    canvas.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;pointer-events:none;';
    footer.appendChild(canvas);

    var ctx = canvas.getContext('2d');

    function resizeCanvas() {
      canvas.width = footer.offsetWidth;
      canvas.height = footer.offsetHeight;
      drawGrain();
    }

    function drawGrain() {
      if (!canvas.width || !canvas.height) return;
      var imageData = ctx.createImageData(canvas.width, canvas.height);
      var data = imageData.data;
      for (var i = 0; i < data.length; i += 4) {
        var noise = Math.random() * 255;
        data[i] = noise;
        data[i + 1] = noise;
        data[i + 2] = noise;
        data[i + 3] = 20;
      }
      ctx.putImageData(imageData, 0, 0);
    }

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
